const normalizeBase = (url) => (url ? url.replace(/\/+$/, "") : "");

const isDevelopment = process.env.NODE_ENV === "development";
const configuredApiUrl = process.env.REACT_APP_API_URL || "";
const defaultApiUrl = isDevelopment ? "" : "api";

export const API_BASE_URL = normalizeBase(
  configuredApiUrl || defaultApiUrl,
);

const mediaFromApi = /(^|\/\/.+)\/api\/?$/.test(API_BASE_URL)
  ? API_BASE_URL.replace(/\/api\/?$/, "")
  : "";
export const MEDIA_BASE_URL = normalizeBase(
  process.env.REACT_APP_MEDIA_BASE_URL || mediaFromApi,
);

export const API_ENDPOINTS = {
  contactCaptcha: "/contact-captcha",
  blogPosts: "/blog-posts",
  blogPostBySlug: (slug) => `/blog-posts/${encodeURIComponent(slug)}`,
  contactSubmit: "/contact-submit",
  instagramPosts: "/instagram-posts",
  youtubePosts: "/youtube-posts",
  about: "/about",
  adminServices: "/admin/services",
  adminServiceStart: (serviceId) => `/admin/services/${encodeURIComponent(serviceId)}/start`,
  adminServiceStop: (serviceId) => `/admin/services/${encodeURIComponent(serviceId)}/stop`,
  adminSyncStatus: "/admin/sync/status",
  adminSyncActivity: "/admin/sync/activity",
  adminSyncChanges: "/admin/sync/changes",
  adminSyncNotion: "/admin/sync/notion",
  adminSyncMeta: "/admin/sync/meta",
  adminSyncYouTube: "/admin/sync/youtube",
  adminSyncAll: "/admin/sync/all",
};
